<dls-springboard (change)="onClick($event)" #springboard>
  <ng-container *ngFor="let group of groupList">
    <ng-container *ngIf="enabledGroupedApps[group]">
      <dls-springboard-group>
        <label class="springboard-header">{{ group | stringTranslate }}</label>
        <dls-springboard-item
          *ngFor="let app of enabledGroupedApps[group]"
          [value]="app.id"
          [selected]="currentApp?.id === app.id">
          <dls-icon [class]="app.icon + ' pt-icon'"></dls-icon>
          <label>{{ app.text | stringTranslate }}</label>
        </dls-springboard-item>
      </dls-springboard-group>
    </ng-container>
  </ng-container>
</dls-springboard>

<div class="springboard-wrapper">
  <button dlsButton class="pt-icon-only pt-quiet" [dlsSpringboardPopup]="springboard">
    <dls-icon class="icon__ImageOverview pt-icon"></dls-icon>
  </button>
</div>
